<template>
  <card class="card">
    <div class="card-body">
      <h2 class="pt-0 mt-0">
        <i class="fas fa-file-invoice text-primary"></i> {{$t('inventory.titleedit')}}
        <small>({{$t('inventory.sku')}}: {{ inventory.part.sku }})</small>
      </h2>
      <hr>
      <div>
        <form @submit.prevent id="userEdit">
          <div class="row">
            <div class="col-md-6">
              <fg-input type="text" :label="$t('inventory.quantitylg')" placeholder v-model="inventory.quantity"></fg-input>
            </div>
          </div>
          <div class="text-left">
            <p-button type="primary" @click.native.prevent="update">{{$t('inventory.button.save')}}</p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </card>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("inventory", {
      inventory: "inventory"
    })
  },
  beforeCreate() {
    this.$store.dispatch("inventory/getInventory", this.$route.params.id);
  },
  methods: {
    update() {
      this.inventory.id = this.$route.params.id;
      this.$store
        .dispatch("inventory/edit", this.inventory)
        .then(response => {
          this.$router.push({ name: "inventory" });
          this.$notify({
            type: "success",
            message: this.$t('inventory.message.successupdate')
          });
        })
        .catch(error => {
          this.$notify({
            type: "danger",
            message: this.$t('inventory.message.errorupdate')
          });
        });
    }
  }
};
</script>
<style>
</style>
